'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _web3Eth = require('web3-eth');

var _web3Eth2 = _interopRequireDefault(_web3Eth);

var _EthWallet = require('./EthWallet');

var _EthWallet2 = _interopRequireDefault(_EthWallet);

var _EthConnectionPool = require('./EthConnectionPool');

var _EthConnectionPool2 = _interopRequireDefault(_EthConnectionPool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Responsible for getting / creating instances of user wallets
 */
var WalletManager = function () {
  function WalletManager(walletDefinitions, walletProviders) {
    var errorMapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (error) {
      return error;
    };
    var defaultFetchPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    _classCallCheck(this, WalletManager);

    this.walletDefinitions = walletDefinitions;
    this.walletProviders = walletProviders;
    this.errorMapper = errorMapper;
    this.instances = {};
    this.defaultFetchPosition = defaultFetchPosition;

    this.isTypeSupported = this.isTypeSupported.bind(this);
  }

  /**
   * changes defaultFetchPosition that is used for address when it comes to EthWallet.
   *
   * @param {Number} position
   * @return {undefined}
   */


  _createClass(WalletManager, [{
    key: 'changeDefaultFetchPosition',
    value: function changeDefaultFetchPosition(position) {
      this.defaultFetchPosition = position;
      return undefined;
    }
  }, {
    key: 'isTypeSupported',
    value: function isTypeSupported(walletType, givenProvider) {
      var _walletDefinitions$fi = this.walletDefinitions.find(function (def) {
        return def.type === walletType;
      }),
          isSupported = _walletDefinitions$fi.isSupported;

      return isSupported(givenProvider);
    }

    /**
     * Gets a wallet service based on the type of wallet
     *
     * @param {String} walletType
     * @param {String} address
     * @return {EthWallet}
     */

  }, {
    key: 'get',
    value: function get(walletType) {
      var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var cacheKey = walletType + address + this.defaultFetchPosition;
      if (this.instances[cacheKey]) {
        return this.instances[cacheKey];
      }

      var provider = this.getProvider(walletType, { address: address });
      var web3 = new _web3Eth2.default(provider);

      var _walletDefinitions$fi2 = this.walletDefinitions.find(function (def) {
        return def.type === walletType;
      }),
          poolSize = _walletDefinitions$fi2.poolSize;

      this.instances[cacheKey] = new _EthWallet2.default(walletType, new _EthConnectionPool2.default((0, _lodash.times)(poolSize, function () {
        return web3;
      })), this.defaultFetchPosition);
      return this.instances[cacheKey];
    }

    /**
     * Get a wallet specific web3 provider.
     *
     * @param {String} walletType
     * @param {Object} walletOptions
     * @return {Object} web3 provider
     */

  }, {
    key: 'getProvider',
    value: function getProvider(walletType, walletOptions) {
      var walletDefinition = this.walletDefinitions.find(function (def) {
        return def.type === walletType;
      });
      if (!walletDefinition) {
        throw new Error('Invalid wallet type: ' + walletType);
      }
      var provider = this.walletProviders[walletType];
      if (!provider) {
        throw new Error('Invalid wallet provider: ' + walletType);
      }
      return provider(walletOptions);
    }
  }]);

  return WalletManager;
}();

exports.default = WalletManager;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/EthWalletManager.js
// module id = 1188
// module chunks = 0